<template>
	<div class="text-left">
		<v-container fluid>
			<image-route-component
				name="Naxxramas"
				logoPath="/assets/wow/classguides.png"
				path="/naxxramas" />
			<image-route-component
				name="Eye of Eternity"
				logoPath="/assets/wow/classguides.png"
				path="/eyeofeternity" />
			<image-route-component
				name="Obsidian Sanctum"
				logoPath="/assets/wow/classguides.png"
				path="/obsidiansanctum" />
		</v-container>
	</div>
</template>

<script>
	import ImageRouteComponent from '../static/ImageRouteComponent.vue';
	export default {
		name: 'WowClassicRaidGuidesComponent',

		components: {
			ImageRouteComponent,
		},

		metaInfo() {
			return {
				title: 'Gaming QoL',
				titleTemplate: '%s | Wow Classic Raid Guides',
				htmlAttrs: {
					lang: 'en',
				},
				meta: [
					{ charset: 'utf-8' },
					{
						vmid: 'description',
						name: 'description',
						content: 'Working description.',
					},
					{
						name: 'viewport',
						content: 'width=device-width, initial-scale=1',
					},
				],
			};
		},
	};
</script>
